<elder-basic-pane-layout class="full">
  <elder-pane class="outlined flex-30">
    <elder-pane-header>
      <elder-pane-title>{{ 'plannedSegments.title' | translate }}</elder-pane-title>
      <elder-pane-actions>
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="requestEnrichmentCmd()">
            <mat-icon> label </mat-icon>
            <span>{{ 'plannedSegments.enrichAgain' | translate }}</span>
          </button>
        </mat-menu>
      </elder-pane-actions>
    </elder-pane-header>
    <elder-pane-content>
      <elder-table
        class="flex"
        matSort
        [data]="plannedSegments()"
        [interactionMode]="'selection'"
        (selectionSingleChange)="selected$.next($event)"
      >
        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="width: 10%">
            {{ 'operations.title' | translate }}
          </th>
          <td mat-cell *matCellDef="let segment">
            <mat-chip-set>
              @for (action of segment.segmentActions; track action) {
                <mat-chip elderChipLabel>{{ action }}</mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>
      </elder-table>
    </elder-pane-content>
  </elder-pane>
  @if (selected$ | async; as segment) {
    <app-item-planned-segment-enrichments
      class="flex-70"
      [plannedSegment]="segment"
    ></app-item-planned-segment-enrichments>
  }
</elder-basic-pane-layout>
